import { render, staticRenderFns } from "./ListItemDragHandle.vue?vue&type=template&id=62ee031d&"
import script from "./ListItemDragHandle.vue?vue&type=script&lang=ts&"
export * from "./ListItemDragHandle.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemDragHandle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports